// extracted by mini-css-extract-plugin
export default {"NavContainer":"NavBarAdmin_NavContainer__8YaJp","NavLink":"NavBarAdmin_NavLink__Z+uyZ"};